
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero","fill":"none"}},[_c('path',{attrs:{"d":"M14 1H5.5C4.675 1 4 1.675 4 2.5v19c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5V7l-3.5-2.5L14 1z","fill":"#1EA463"}}),_c('path',{attrs:{"d":"M18.5 22.875h-13c-.825 0-1.5-.675-1.5-1.5v.125c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-.125c0 .825-.675 1.5-1.5 1.5z","fill":"#158752"}}),_c('path',{attrs:{"d":"M8 11.75V19h8v-7.25H8zM11.5 18H9v-1.25h2.5V18zm0-2H9v-1.25h2.5V16zm0-2H9v-1.25h2.5V14zm3.5 4h-2.5v-1.25H15V18zm0-2h-2.5v-1.25H15V16zm0-2h-2.5v-1.25H15V14z","fill":"#F1F1F1"}}),_c('path',{attrs:{"fill":"#1A985D","d":"M14.439 6.561L20 12.121V7z"}}),_c('path',{attrs:{"d":"M14 1v4.5A1.5 1.5 0 0015.5 7H20l-6-6z","fill":"#87CEAC"}})])])
          )
        }
      }
    